import { Component } from '@angular/core';

@Component({
    // moduleId: module.id,
    selector: 'add-comment',
    templateUrl: 'add-comment.component.html',
    styleUrls: ['add-comment.component.scss']
})
export class AddCommentComponent {

}
